/* Copyright (c) 2017-2022 VMware, Inc. All rights reserved. VMware Confidential */

import { ChangeDetectorRef, ComponentFactory, ComponentFactoryResolver, ComponentRef, Directive, HostListener, Input, Renderer2, ViewContainerRef } from "@angular/core";
import { DrClipboardIconComponent } from "@shared/directives/dr-show-title/dr-clipboard-icon.component";

// @formatter:off
@Directive({
    selector: "[dr-show-title]",
    host: {
        "[style.overflow]": "\"hidden\"",
        "[style.text-overflow]": "\"ellipsis\"",
        "[style.white-space]": "\"nowrap\""
    }
})
// @formatter:on
export class ShowTitleDirective {

    private static readonly CLIPBOARDICON_TAGS: string = "clr-dg-cell";

    @Input() copyToClipboard: boolean = false;

    private clipboardIcon: ComponentRef<DrClipboardIconComponent>;
    private hostPaddingRight: string = "";

    constructor(
        private viewContainerRef: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private renderer: Renderer2,
        private cdr: ChangeDetectorRef) {
    }

    @HostListener("mouseenter") show(): void {
        const el: HTMLElement = this.viewContainerRef.element.nativeElement;

        /* checks if text ellipsis is active */
        if (el.offsetWidth < el.scrollWidth) {
            el.title = el.innerText;
            /* checks if the target element is in our list of usage CLIPBOARDICON_TAGS */
            if ((this.viewContainerRef.element.nativeElement.localName === ShowTitleDirective.CLIPBOARDICON_TAGS) || this.copyToClipboard) {
                el.style.position = "relative";
                const factory: ComponentFactory<DrClipboardIconComponent> = this.resolver.resolveComponentFactory(
                    DrClipboardIconComponent);
                this.clipboardIcon = this.viewContainerRef.createComponent(factory);
                this.renderer.appendChild(this.viewContainerRef.element.nativeElement,
                                          this.clipboardIcon.injector.get(
                                              DrClipboardIconComponent).element.nativeElement);
                this.clipboardIcon.instance.content = el.innerText;
            }
        } else {
            el.title = "";
            el.style.position = "initial";
        }
    }

    @HostListener("mouseleave") hide(): void {
        if (this.clipboardIcon) {
            this.clipboardIcon.destroy();
            this.renderer.removeChild(this.viewContainerRef.element.nativeElement,
                                      this.clipboardIcon.injector.get(DrClipboardIconComponent).element.nativeElement);
            this.cdr.detectChanges();
        }
    }
}
